import { FC, useState } from 'react';
import { ProductVM } from '../../../../common/view-model';
import './DistributionComponent.scss';
import { distributionState } from './model';
import { PackagingComponent } from '../packaging/PackagingComponent';
// import { HowItsMadeComponent } from '../howItsMade/HowItsMadeComponent';
interface IDistributionComponentProps {
	product: ProductVM | undefined;
}
export const DistributionComponent: FC<IDistributionComponentProps> = ({ product }) => {
	const [state] = useState({ ...distributionState });
	// const joinedChannels = product?.brand.current_retail_channels?.split(';').join(',').concat('.');
	const mappedValues = state.mapValuesForTable(product?.brand?.regionsBydistributor);
	return (
		<>
			<div data-testid='distribution-component' className='distribution-container'>
				<div className='distribution-table-container'>
					<div className='distribution-tabletitle'>{state.tableTitle}</div>
					<div className='distribution-title'>{state.title}</div>
					{mappedValues && Object.keys(mappedValues).length > 0 && (
						<table>
							<tbody>
								{Object.entries(mappedValues).map(([distributor_name, region_name]: any) => (
									<tr key={distributor_name}>
										<td
											className={
												distributor_name === 'Not in Distribution'
													? 'not-distribution'
													: 'yes-distribution'
											}
										>
											{distributor_name}
										</td>
										<td
											className={
												distributor_name === 'Not in Distribution'
													? 'not-distribution'
													: 'yes-region'
											}
										>
											{region_name}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</div>
				{/* <div data-testid='distribution-block' className='distribution-block'>
					<span className='distribution-title'>{state.channelsText.key}</span>
					<span>{joinedChannels}</span>
				</div> */}
			</div>
			<div className='product-packaging'>
				<span className='product-packaging-heading'> Product Packaging </span>
				<PackagingComponent product={product} />
			</div>
			{/* <div>
				<span> Processing Techniques </span>
				<HowItsMadeComponent product={product} />
			</div> */}
		</>
	);
};
